import SonicTerm, { SonicTermData } from "./SonicTerm";

export interface SonicApplicationData {
  id: string;
  message: string;
  timestamp: number;
  status: string;
  applicant_id: string;
  applicant_name: string;
  applicant_full_name: string;
  applicant_email: string;
  applicant_roles: Array<string>;
  applicant_school?: SonicTermData;
  project_id: string;
  memo: string;
}

export default class SonicApplication implements SonicApplicationData {
  id: string;
  message: string;
  timestamp: number;
  status: string;
  applicant_id: string;
  applicant_name: string;
  applicant_full_name: string;
  applicant_email: string;
  applicant_roles: Array<string>;
  applicant_school?: SonicTermData;
  project_id: string;
  memo: string;
  
  constructor(
    id: string,
    message: string,
    timestamp: number,
    status: string,
    applicant_id: string,
    applicant_name: string,
    applicant_full_name: string,
    applicant_email: string,
    applicant_roles: Array<string>,
    applicant_school: SonicTermData,
    project_id: string,
    memo: string
  ) {
    this.id = id;
    this.message = message;
    this.timestamp = timestamp;
    this.status = status;
    this.applicant_id = applicant_id;
    this.applicant_name = applicant_name;
    this.applicant_full_name = applicant_full_name;
    this.applicant_email = applicant_email;
    this.applicant_roles = applicant_roles;
    this.applicant_school =
      applicant_school && SonicTerm.parseFromAPIResponse(applicant_school);
    this.project_id = project_id;
    this.memo = memo;
  }

  static parseFromAPIResponse(item: any) {
    return new SonicApplication(
      item.id,
      item.message,
      item.timestamp,
      item.status,
      item.applicant_id,
      item.applicant_name,
      item.applicant_full_name,
      item.applicant_email,
      item.applicant_roles,
      item.applicant_school,
      item.project_id,
      item.memo
    );
  }
}
